module.exports = __webpack_public_path__ + "static/media/odopass.6e67c2bb.png";